/**
 * ToolbarTitle  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { BEM } from "@adapptio/lib-components";
import React from "react";

export interface ToolbarNoteProps {
	className?: string;
}

export const ToolbarNote: React.FC<ToolbarNoteProps> = ({ children, className }) => {
	const baseClass = BEM("edt-toolbar-note");

	if (className) {
		baseClass.add(className);
	}

	return <div className={baseClass.toClassName()}>{children}</div>;
};
